module.exports = __webpack_public_path__ + "images/delete-view-db7f4974.svg";